import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Tooltip as MuiTooltip } from '@mui/material';

import { LightTheme, DarkTheme } from 'src/packages/theme';
import { TooltipProps } from './Tooltip.types';

const Tooltip = ({
  arrow = true,
  type,
  placement = 'bottom',
  title = 'Tooltip text',
  children,
  theme,
  ...rest
}: TooltipProps) => {
  const contextTheme = useTheme();

  const defaultTheme = useMemo(() => {
    return theme
      ? theme === 'light'
        ? { ...LightTheme, rtl: contextTheme.rtl }
        : { ...DarkTheme, rtl: contextTheme.rtl }
      : contextTheme;
  }, [contextTheme, theme]);

  const colors = useMemo(() => {
    let textColor = defaultTheme.colors.palette.white;
    let backgroundColor;

    switch (type) {
      case 'success':
        backgroundColor = defaultTheme.colors.palette.green;
        break;
      case 'error':
        backgroundColor = defaultTheme.colors.palette.red;
        break;
      case 'warning':
        backgroundColor = defaultTheme.colors.palette.orange;
        break;
      case 'info':
        backgroundColor = defaultTheme.colors.palette.blue;
        break;
      default:
        backgroundColor = defaultTheme.colors.background.secondary.BG4;
        textColor = defaultTheme.colors.text.secondary;
    }

    return { textColor, backgroundColor };
  }, [defaultTheme, type]);

  return (
    <MuiTooltip
      {...rest}
      title={title}
      placement={placement}
      arrow={arrow}
      componentsProps={{
        popper: {
          sx: {
            zIndex: 12100,
          },
        },
        tooltip: {
          sx: {
            bgcolor: colors.backgroundColor,
            color: colors.textColor,
          },
        },
        arrow: {
          sx: {
            color: colors.backgroundColor,
          },
        },
      }}
    >
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
